<template lang="pug">
  .search-input.container.mx-auto
    input.search-input(
        type="text"
        placeholder="suchen..."
        ref="input"
        v-model="query"
        :autofocus="autofocus"
        @keydown.enter="submitSearch"
        @focus="$event.target.select()"
    )
    button.button.is-outlined(@click="submitSearch") Suchen
</template>

<script>
import { get } from '@/helpers';
import uniqid from 'uniqid';

export default {
    name: 'SearchInput',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        query: ''
    }),
    watch: {
        '$route.query'(query) {
            this.query = get(query, 's');
            this.$nextTick(() => {
                if (this.addToCart) {
                    this.$refs.input.focus();
                    this.$refs.input.select();
                }
            });
        }
    },
    computed: {
        autofocus() {
            let autofocus = true;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'autofocus');
                if (setting && setting.value !== undefined) autofocus = setting.value;
            }
            return autofocus;
        },
        addToCart() {
            let addToCart = false;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'add-to-cart');
                if (setting && setting.value !== undefined) addToCart = setting.value;
            }
            return addToCart;
        }
    },
    methods: {
        submitSearch() {
            let query = { ...this.$route.query, uid: uniqid(), s: this.query };
            if (this.addToCart) query['add-to-cart'] = true;
            this.$router.replace({ name: this.$route.name, query });
        }
    },
    mounted() {
        this.query = get(this.$route, 'query.s');
        this.$nextTick(() => {
            if (this.autofocus) this.$refs.input.focus();
        });
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
.search-input
    display: flex
    margin-bottom: 1rem
    gap: 1rem
    button
        height: 37px
</style>
